import { render, staticRenderFns } from "./MsButton.vue?vue&type=template&id=100ca61d&scoped=true"
import script from "./MsButton.vue?vue&type=script&lang=js"
export * from "./MsButton.vue?vue&type=script&lang=js"
import style0 from "./MsButton.vue?vue&type=style&index=0&id=100ca61d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "100ca61d",
  null
  
)

export default component.exports